import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./UserPlanStyle.css";
import "../ProjectV2/Render/RenderStyle.css";

import Navbar from "../ProjectV2/Navbar/Navbar";
import UserPlanNav from "./UserPlanNav";
import SliderRectCard from "./SliderRectCard";
import PaymentsDetails from "../UserPlan/PaymentsDetails";

import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentPlan,
  getRendersPlan,
  PlanHandler,
} from "../../Redux/actions/commonActtion";

import { toast } from "react-toastify";
import CustomToast, {
  defaultcustomToatStyle,
} from "../../Components/CustomToast/CustomToast";

const AllPlansList = ({ setRenderOpen, isPlanShow, setIsPlanShow }) => {
  // console.log('1 AllPlansList');

  const location = useLocation();
  // console.log('AllPlansList location = ',location);
  const { isDashboard, projectId, isCard, pathSegment, isMoreInfo, isRender } =
    location.state || {};
  // console.log("AllPlansList Received Project ID: isCard", projectId, isCard, pathSegment);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));

  const [currentPlanRange, setCurrentPlanRange] = useState({
    start: 0,
    end: 2,
  });
  const [isOpen, setIsOpen] = useState(false);

  const [selectedPlan, setSelectedPlan] = useState({});

  const [isSuccessOpen, setIsSuccessOpen] = useState(false);

  const { renderPlan } = useSelector((state) => state.commonReducer);

  const commonReducer = useSelector((state) => state?.commonReducer);
  const currentPlan = commonReducer?.currentPlan;
  const subscription_status =
    commonReducer?.currentPlan?.plan?.subscription_status;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;
  const [isUserPaid, setIsUserPaid] = useState(
    currentPlan.success && currentPlan.plan ? true : false,
  );

  useEffect(() => {
    getRenderPlanDetails();
  }, [isSuccessOpen]);

  const getRenderPlanDetails = async () => {
    await dispatch(getRendersPlan(user));
    await dispatch(getCurrentPlan());
  };

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${createdAt?.getMonth() + 1}/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const today = new Date();
  const planRenewDate = new Date(
    createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000,
  );
  let timeDifference = planRenewDate - today;

  useEffect(() => {
    let prevRemainingDays = remainingDays;

    if (remainingDays === 1 || validityValue === 1) {
      const interval = setInterval(() => getTime(prevRemainingDays), 1000);
      return () => clearInterval(interval);
    } else {
      getTime(prevRemainingDays);
    }
  }, [remainingDays, validityValue, timeDifference]);

  const getTime = async (prevRemainingDays) => {
    if (!isNaN(validityValue)) {
      if (timeDifference > 0) {
        if (timeDifference >= 24 * 60 * 60 * 1000) {
          const updatedRemainingDays = Math.ceil(
            timeDifference / (24 * 60 * 60 * 1000),
          );
          timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

          if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
            setRemainingHours(0);
            setRemainingMinutes(0);
            setRemainingSeconds(0);
            setIsUserPaid(false);
          }
          setRemainingDays(updatedRemainingDays);
        }
        if (timeDifference >= 60 * 60 * 1000) {
          setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
          timeDifference -= remainingHours * 60 * 60 * 1000;
        }

        if (timeDifference >= 60 * 1000) {
          setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
          timeDifference -= remainingMinutes * 60 * 1000;
        }

        setRemainingSeconds(Math.floor(timeDifference / 1000));
      } else if (remainingDays === 0) {
        setIsUserPaid(false);
        // console.log('prevRemainingDays', prevRemainingDays, "timeDifference", timeDifference, "remainingDays", remainingDays);
      } else {
        setRemainingDays(0);
        setRemainingHours(0);
        setRemainingMinutes(0);
        setRemainingSeconds(0);
      }
    }
  };

  const expirationMessage =
    remainingDays === 1 || validityValue === 1
      ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
      : remainingDays > 1
        ? `Remaining days ${remainingDays}`
        : Object.keys(currentPlan).length === 0
          ? "Buy New Plan"
          : "Plan Expired ";

  const goToNextPlan = () => {
    if (currentPlanRange.end < renderPlan.length - 1) {
      setCurrentPlanRange({
        start: currentPlanRange.start + 1,
        end: currentPlanRange.end + 1,
      });
    }
  };

  const goToPreviousPlan = () => {
    if (currentPlanRange.start > 0) {
      setCurrentPlanRange({
        start: currentPlanRange.start - 1,
        end: currentPlanRange.end - 1,
      });
    }
  };

  const isEmptyObject =
    currentPlan &&
    Object.keys(currentPlan).length === 0 &&
    currentPlan.constructor === Object;

  const handleUpgradeOnSubscriptionActive = (plan) => {
    if (
      plan?._id !== currentPlan?.plan?.plan_detail?._id &&
      plan?.price !== 0
    ) {
      toast(
        <CustomToast
          title=""
          content={
            "You're already subscribed, Please cancel your current plan first and then upgrade your plan"
          }
        />,
        defaultcustomToatStyle,
      );
    }
  };

  const navigateHandler = (selectplanVal) => {
    setSelectedPlan(selectplanVal);
    setIsOpen(true);
    dispatch(PlanHandler(selectplanVal));

    if (isDashboard && isMoreInfo) {
      // From Dashboard => MoreInfo => User-Plan => UserPlan Details
      navigate("/user-plan/plan&payment-details", {
        state: {
          isDashboard: true,
          isMoreInfo: true,
          selectedPlan: selectplanVal,
        },
      });
    }

    // From Card Project => MoreInfo => User-Plan => UserPlan Details
    else if (!isDashboard && isMoreInfo) {
      navigate("/user-plan/plan&payment-details", {
        state: {
          isDashboard: isDashboard,
          isMoreInfo: isMoreInfo,
          isCard: isCard,
          projectId: projectId,
          selectedPlan: selectplanVal,
        },
      });
    } else if (isRender && !isMoreInfo && isCard) {
      // From Render - Card Project => Upgrade => User-Plan => UserPlan Details
      navigate("/user-plan/plan&payment-details", {
        state: {
          isDashboard: isDashboard,
          isRender: true,
          isMoreInfo: false,
          projectId: projectId,
          isCard: isCard,
          selectedPlan: selectplanVal,
        },
      });
    } else if (isRender && !isMoreInfo && !isCard) {
      // From Render - Scroll Project => Upgrade => User-Plan => UserPlan Details
      navigate("/user-plan/plan&payment-details", {
        state: {
          isDashboard: isDashboard,
          isRender: true,
          isMoreInfo: false,
          projectId: projectId,
          isCard: isCard,
          selectedPlan: selectplanVal,
        },
      });
    }
  };

  return (
    <>
      {isPlanShow || (
        <div className="w-full h-full">
          <div className={`UpgradePlan-container`}>
            {/* <div className="UpgradePlan-overlay"></div> */}

            <div className="UpgradePlan-content w-full ">
              <div className="UpgradePlan-header h-[6.8%] w-full h-hull flex items-center pl-[3px] pr-[3px] bg-[#171717]">
                <UserPlanNav />
              </div>

              <div className="UpgradePlan-contentt w-full h-[93.2%] SCalePlan">
                <div className="w-full h-[13.5%] flex flex-col justify-end items-center text-center bg-[#121212] headcontent">
                  <h1 className="text-[42px]  manrope-600 py-2 tracking-wide text-white">
                    Choose the plan that fits your needs
                  </h1>
                  <h2 className="text-[16px]  manrope-400  tracking-wide text-[#ffffffcc]">
                    From quick turn arrounds to long-term projects,we've got a
                    plan that's just right for you
                  </h2>
                </div>

                <div className="w-[100%] h-[90%] flex justify-center item-center">
                  <div className="flex justify-center items-center pb-[3%] pt-[1%] h-full w-[62%] ">
                    {renderPlan
                      .slice(currentPlanRange.start, currentPlanRange.end + 1)
                      .map((plan, ind) => (
                        // console.log('plan=',plan),
                        <div
                          className={`w-[29%] plan-box rounded-[20px] UpgradePlanBG p-5 ${ind === 1 ? "mx-[5%]" : ""} 
                    ${plan?.price === 0 || subscription_status === 1 ? "" : "cursor-pointer HoverPlanCLASS"}  `}
                          key={`upg${ind + 1}`}
                          onClick={
                            (subscription_status === 2 && plan?.price !== 0) ||
                            (subscription_status === undefined &&
                              plan?.price !== 0)
                              ? () => {
                                  setSelectedPlan(plan);
                                  navigateHandler(plan);
                                }
                              : () => handleUpgradeOnSubscriptionActive(plan)
                          }
                        >
                          <SliderRectCard
                            planId={plan?._id}
                            plantype={plan?.type}
                            planText={plan?.text5}
                            moneyBackText={plan?.text6}
                            currency={plan?.currency}
                            PlanPrice={plan?.price}
                            PlanInterval={plan?.interval_validity}
                            renderLimit={plan?.text1}
                            renderType={plan?.text2}
                            formateType={plan?.text3}
                            cancelCondition={plan?.text4}
                            daysLimit={plan?.validity}
                            currentPlan={currentPlan}
                            currentPlanDetails={currentPlanDetails}
                            currentPlanId={currentPlanDetails?._id}
                            subscription_status={subscription_status}
                          />
                        </div>
                      ))}
                  </div>
                </div>

                {/* <button className="prev-button" onClick={goToPreviousPlan} disabled={currentPlanRange.start === 0}><span>&lt;</span></button>
            <button className="next-button" onClick={goToNextPlan} disabled={currentPlanRange.end === renderPlan.length - 1}><span>&gt;</span></button> */}

                {isOpen && (
                  <PaymentsDetails
                    setRenderOpen={setRenderOpen}
                    isPlanShow={isPlanShow} // From Render-Page - Boolean State
                    isOpen={isOpen}
                    setIsOpen={setIsOpen} // From AllPlanList (Upgrade Plan) - Boolean State
                    selectedPlan={selectedPlan}
                    currentPlanDetails={currentPlanDetails} // From Redux Store
                    paymentType={currentPlan?.plan?.payment_type} // From Redux Store
                    order_id={currentPlan?.plan?.order_id} // From Redux Store
                    subscription_status={currentPlan?.plan?.subscription_status} // From Redux Store
                    planPurchaseDate={planPurchaseDate}
                    getTime={getTime}
                    remainingDays={remainingDays}
                    expirationMessage={expirationMessage}
                    setIsSuccessOpen={setIsSuccessOpen} // getRenderPlanDetails on state change
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AllPlansList;
